export const mockStats = {
  activeCampaigns: 14,
  postsScheduled: 128,
  pendingApprovals: 9,
  engagementRate: "+24.5%",
};

export const mockApprovals = [
  { id: 1, title: "Q3 Feature Launch Thread", channel: "Twitter", author: "Sarah J.", time: "2h ago", status: "pending" },
  { id: 2, title: "CEO Interview Snippet", channel: "LinkedIn", author: "Mike T.", time: "4h ago", status: "pending" },
  { id: 3, title: "Product Update Reel", channel: "Instagram", author: "Elena R.", time: "5h ago", status: "pending" },
];

export const mockCalendarData = [
  { id: 1, date: new Date(), title: "Weekly Newsletter", type: "Email", status: "scheduled", time: "10:00 AM" },
  { id: 2, date: new Date(), title: "Platform Update 2.1", type: "Twitter", status: "draft", time: "02:00 PM" },
  { id: 3, date: new Date(new Date().setDate(new Date().getDate() + 1)), title: "Behind the Scenes", type: "Instagram", status: "approved", time: "11:30 AM" },
  { id: 4, date: new Date(new Date().setDate(new Date().getDate() + 2)), title: "Industry Report Q2", type: "LinkedIn", status: "scheduled", time: "09:00 AM" },
];

export const mockOrbitCampaigns = [
  { id: 1, name: "Rebrand Launch", orbit: 1, angle: 45, color: "#FF5A5F", status: "Active", progress: 80 },
  { id: 2, name: "Holiday Promo", orbit: 1, angle: 220, color: "#8B5CF6", status: "Planning", progress: 30 },
  { id: 3, name: "Webinar Series", orbit: 2, angle: 90, color: "#10B981", status: "Active", progress: 65 },
  { id: 4, name: "User Conf 2024", orbit: 2, angle: 280, color: "#F59E0B", status: "Drafting", progress: 15 },
  { id: 5, name: "Partner Outreach", orbit: 3, angle: 150, color: "#3B82F6", status: "Active", progress: 45 },
  { id: 6, name: "SEO Refresh", orbit: 3, angle: 330, color: "#EC4899", status: "Review", progress: 90 },
];

export const mockAssets = [
  { id: 1, name: "Hero_Image_V2.png", type: "image", size: "2.4 MB", url: "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=2564&auto=format&fit=crop" },
  { id: 2, name: "Logo_Neon_Pack.zip", type: "archive", size: "15 MB", url: "https://images.unsplash.com/photo-1557672172-298e090bd0f1?q=80&w=2487&auto=format&fit=crop" },
  { id: 3, name: "Promo_Video_Draft.mp4", type: "video", size: "124 MB", url: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=2000&auto=format&fit=crop" },
  { id: 4, name: "Social_Banners_Q3.fig", type: "design", size: "8.1 MB", url: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?q=80&w=2000&auto=format&fit=crop" },
];